import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from './auth.interceptor';
import { DatePipe } from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LoginComponent } from './login/login.component';
import { SuperAdminDashboardComponent } from './super-admin-dashboard/super-admin-dashboard.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatTabsModule } from '@angular/material/tabs';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import {MatSortModule} from '@angular/material/sort';
import {MatTableModule} from '@angular/material/table';
import {ScrollingModule} from '@angular/cdk/scrolling';
import {MatTreeModule} from '@angular/material/tree';
import { SuperAdminLayoutComponent } from './super-admin-layout/super-admin-layout.component';
import { AdminLayoutComponent } from './admin-layout/admin-layout.component';
import { UserLayoutComponent } from './user-layout/user-layout.component';
import { AdminDashboardComponent } from './admin-dashboard/admin-dashboard.component';
import { UserDashboardComponent } from './user-dashboard/user-dashboard.component';
import { SuperAdminHeaderComponent } from './super-admin-header/super-admin-header.component';
import { AdminHeaderComponent } from './admin-header/admin-header.component';
import { UserHeaderComponent } from './user-header/user-header.component';
import { AddBusinessComponent } from './add-business/add-business.component';
import { SuperAdminSidenavComponent } from './super-admin-sidenav/super-admin-sidenav.component';
import { AdminSidenavComponent } from './admin-sidenav/admin-sidenav.component';
import { UserSidenavComponent } from './user-sidenav/user-sidenav.component';
import { AddUserComponent } from './add-user/add-user.component';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatExpansionModule} from '@angular/material/expansion';
import { AddPartyComponent } from './add-party/add-party.component';
import { SlipFormComponent } from './slip-form/slip-form.component';
import { InvoiceFormComponent } from './invoice-form/invoice-form.component';
import { SlipViewComponent } from './slip-view/slip-view.component';
import { UnpaidInvoiceViewComponent } from './unpaid-invoice-view/unpaid-invoice-view.component';
import { PaidInvoiceViewComponent } from './paid-invoice-view/paid-invoice-view.component';
import { ItemMasterComponent } from './item-master/item-master.component';
import { UnpaidInvoiceFormComponent } from './unpaid-invoice-form/unpaid-invoice-form.component';
import { SlipToInvoiceFormComponent } from './slip-to-invoice-form/slip-to-invoice-form.component';
import { RoleMasterComponent } from './role-master/role-master.component';
import { LevelSelectorComponent } from './level-selector/level-selector.component';
import { LastRoleUsersListComponent } from './last-role-users-list/last-role-users-list.component';
import { MobileDashboardComponent } from './mobile-dashboard/mobile-dashboard.component';
import { AddBusinessUsersComponent } from './add-business-users/add-business-users.component';
import { SlipDirectAmountFormComponent } from './slip-direct-amount-form/slip-direct-amount-form.component';
import { InvoiceDirectAmountFormComponent } from './invoice-direct-amount-form/invoice-direct-amount-form.component';
import { PrintLayoutComponent } from './print-layout/print-layout.component';
import { SlipPrintComponent } from './slip-print/slip-print.component';
import { InvoicePrintComponent } from './invoice-print/invoice-print.component';
import { InvoicePopupComponent } from './app.component';
import { SlipPopupComponent } from './app.component';
import { PreferencesComponent } from './preferences/preferences.component';
import { AdminProfileComponent } from './admin-sidenav/admin-sidenav.component';
import { UserProfileComponent } from './user-sidenav/user-sidenav.component';
import { HammerGestureConfig, HAMMER_GESTURE_CONFIG } from '@angular/platform-browser';
import { SwipeTabDirective } from './swipe-tab.directive';
import { EditSlipComponent } from './edit-slip/edit-slip.component';
import { AddRecordPopupComponent } from './edit-slip/edit-slip.component';
import { AddInvoiceRecordPopupComponent } from './edit-invoice/edit-invoice.component';
import { EditInvoiceComponent } from './edit-invoice/edit-invoice.component';
@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    SuperAdminDashboardComponent,
    PageNotFoundComponent,
    SuperAdminLayoutComponent,
    AdminLayoutComponent,
    UserLayoutComponent,
    AdminDashboardComponent,
    UserDashboardComponent,
    SuperAdminHeaderComponent,
    AdminHeaderComponent,
    UserHeaderComponent,
    AddBusinessComponent,
    SuperAdminSidenavComponent,
    AdminSidenavComponent,
    UserSidenavComponent,
    AddUserComponent,
    AddPartyComponent,
    SlipFormComponent,
    InvoiceFormComponent,
    SlipViewComponent,
    UnpaidInvoiceViewComponent,
    PaidInvoiceViewComponent,
    ItemMasterComponent,
    UnpaidInvoiceFormComponent,
    SlipToInvoiceFormComponent,
    RoleMasterComponent,
    LevelSelectorComponent,
    LastRoleUsersListComponent,
    MobileDashboardComponent,
    AddBusinessUsersComponent,
    SlipDirectAmountFormComponent,
    InvoiceDirectAmountFormComponent,
    PrintLayoutComponent,
    SlipPrintComponent,
    InvoicePrintComponent,
    InvoicePopupComponent,
    SlipPopupComponent,
    PreferencesComponent,
    AdminProfileComponent,
    UserProfileComponent,
    SwipeTabDirective,
    EditSlipComponent,
    AddRecordPopupComponent,
    EditInvoiceComponent,
    AddInvoiceRecordPopupComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    BsDatepickerModule.forRoot(),
    NgbModule,
    MatChipsModule,MatIconModule,MatSlideToggleModule,MatTooltipModule,ScrollingModule,
    MatDialogModule, MatTabsModule,HttpClientModule, MatAutocompleteModule, MatRadioModule,
    MatDatepickerModule,MatNativeDateModule, MatSelectModule, MatButtonModule, MatCheckboxModule,
    MatInputModule, MatTreeModule, MatProgressBarModule, MatExpansionModule, MatSortModule,MatTableModule
  ],
  providers: [
    HttpClient,
    DatePipe,
    { provide: HAMMER_GESTURE_CONFIG, useClass: HammerGestureConfig },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
